import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-main',
  templateUrl: './work-main.component.html'
})
export class WorkMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/work/components/work-main.component.ts